import { Controller } from "@hotwired/stimulus"

// "Revisar y cerrar": shows the checkboxes already rendered on Por revisar cells and the sticky bar.
// It only toggles visibility and the selected count. The server renders the markup.
export default class extends Controller {
  static targets = ["reviewOnly", "reviewHide", "count", "submit"]

  connect() {
    this.reviewing = false
    this.updateCount()
  }

  toggle() {
    this.reviewing = !this.reviewing
    this.reviewOnlyTargets.forEach((element) => element.classList.toggle("hidden", !this.reviewing))
    this.reviewHideTargets.forEach((element) => element.classList.toggle("hidden", this.reviewing))
    this.updateCount()
  }

  updateCount() {
    const checked = this.element.querySelectorAll("input[name='cohort_ids[]']:checked").length
    if (this.hasCountTarget) this.countTarget.textContent = String(checked)
    if (this.hasSubmitTarget) this.submitTarget.disabled = checked === 0
  }
}
